'use strict';//Indicating browser should run only in java script mode



//*******PURPOSE: THIS Controller is created for Showing the mobile version of web 
//*******EFFECTIVE FILES:EMRWEB/Common/EHRWebViewInMobile.html
//*******CREATED BY:Anusha Ch
//*******CREATED DATE:07/17/2017
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Admin').directive('emrEhrWebViewInMobile', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: GetEMRPageURLByPageName("EMRWEB/Common/EHRWebViewInMobile.html"),//GetEMRPageURLByIndex(672),//359
        controller: "EHRWebViewInMobileDirective",//controller to bind
        controllerAs: "vm",bindToController: true,//
        scope: {
            /* NOTE: Normally I would set my attributes and bindings
            to be the same name but I wanted to delineate between 
            parent and isolated scope. */
            //isolatedAttributeFoo:'@attributeFoo',
            EHRWebViewInMobileOptions: '=options',//this is readed from the controller
            // isolatedExpressionFoo:'&'
        },
        link: {
            //this method executes when the link function has started
            pre: function preLink($scope, $iElement, $iAttrs, $controller) {
            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink($scope, $iElement, $iAttrs, $controller) {
                var unbindWatchers = $scope.$watch('vm.EHRWebViewInMobileOptions', function () {
                    $scope.EHRWebViewInMobileDirectivePageInit();
                });

                //on destroy clearing the events on nodes and removing the elements from the DOM
                $iElement.on('$destroy', function () {
                    unbindWatchers();
                    ehrDirectiveElementsOnDestroyEvent($iElement);
                });

            }
        },
    })
}).controller('EHRWebViewInMobileDirective', ["$scope", "LoginService", "ModalPopupService", "$rootScope", "InBoxService", "EMRCommonFactory", "$timeout", function ($scope, LoginService, ModalPopupService, $rootScope, InBoxService, EMRCommonFactory, $timeout) {

    //############# PAGE INITLIZATION BLOCK START  ##################
    //*******PURPOSE: this method is used to initialize the page
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    $scope.EHRWebViewInMobileDirectivePageInit = function () {
        //to bind user name
        if (hasValue(EMRPracticeModel) && hasValue(EMRPracticeModel.FirstName)) {
            $scope.EMRLoggedInUserFullNameinMobile = "Hello" + " " + EMRPracticeModel.FirstName + " " + EMRPracticeModel.LastName;
        }

        $scope.homePageMobileLoadPreviousContentIsInBoxFoldersOpened = false;

        $scope.EHRWebViewInMobileGUID = adminGetGUID();
        $scope.ehrHomePageIsNormalLogout = false;

        if (hasValue($scope.vm.EHRWebViewInMobileOptions)) {


            //this options are used to navigate the menus and pass the related information
            $scope.vm.EHRWebViewInMobileOptions.setMenusNavigationList = function (MenuList, type) {

                //FOR DASHBOARD
                if (type == 1) {
                    $scope.dashfolderShowInMobileList = MenuList;
                    /**
                     * commented these functions no use of it in mobile resolution
                     */
                    //$scope.dashBoardMenuItems = MenuList;
                    //$scope.dashboardLeftFoldersLinkedListForMobile();
                    if (EHRisMobile.anyMobile())
                        $(window).scrollTop(0);
                }
                    //FOR INBOX
                else if (type == 2) {
                    $scope.inboxShowInMobileList = MenuList;
                    /**
                     * commented these functions no use of it in mobile resolution
                     */
                    //$scope.inboxMenuItemsForMobile = MenuList;
                    //$scope.inboxLinkedListForMobile();
                }
                    //FOR PATIENT CHARTS
                else if (type == 3) {

                    ///////////// assigning the mobile customized show menus list only to show in mobile
                    var tempFilteredChartList = [];

                    if (hasValue(MenuList.List)) {
                        tempFilteredChartList = $.grep(MenuList.List, function (folderItem) {
                            //except desktop menu items
                            return folderItem.ShowIn != 1;
                        });
                    }

                    //if (!hasValue(tempFilteredChartList) || tempFilteredChartList.length <= 0) {
                    //    tempFilteredChartList = angular.copy(MenuList.List);
                    //}

                    //sorting the array  when there exists data
                    if (hasValue(tempFilteredChartList) && tempFilteredChartList.length > 0) {
                        tempFilteredChartList.sortByKey("PatientLinkedMobileDisplaySequence");
                    }

                    //re assigning the filtered list
                    MenuList.List = tempFilteredChartList;

                    //patient chart 1
                    if (MenuList.PatientChartSeqNumber == "1") {
                        $scope.patientChart1ShowInMobileList = MenuList.List;
                        //$scope.ehrMobilePatientChart1List();
                        $scope.patientChart1PatientInfo = MenuList.PatientInfo;
                    }
                        //patient chart 2
                    else if (MenuList.PatientChartSeqNumber == "2") {
                        $scope.patientChart2ShowInMobileList = MenuList.List;
                        //$scope.ehrMobilePatientChart2List();
                        $scope.patientChart2PatientInfo = MenuList.PatientInfo;
                    }
                        //patient chart 3
                    else if (MenuList.PatientChartSeqNumber == "3") {
                        $scope.patientChart3ShowInMobileList = MenuList.List;
                        //$scope.ehrMobilePatientChart3List();
                        $scope.patientChart3PatientInfo = MenuList.PatientInfo;
                    }

                    //this method is used to make the toggle the active item when content was toggled to desktop and viceversa
                    $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(4, MenuList);

                    //this is used to hide the patient chart menus as per the click
                    $scope['patientChart' + MenuList.PatientChartSeqNumber + 'InformationShow'] = true;
                    $scope['patientChart' + MenuList.PatientChartSeqNumber + 'InformationShowHeader'] = true;
                }

            };


            //this method is useful in while closing the chart in ehr stac menu to hide and clear the respected chart inforation
            $scope.vm.EHRWebViewInMobileOptions.onPatientChartClose = function (chartSequenceClosed) {
                //hiding all and shwing the dash board only
                $scope.inboxMenuMobileOptions = false;
                $scope.patientChart1InformationShow = false;
                $scope.patientChart2InformationShow = false;
                $scope.patientChart3InformationShow = false;

                //clering all the current chart info
                $scope['patientChart' + chartSequenceClosed + 'PatientInfo'] = undefined;
                $scope['patientChart' + chartSequenceClosed + 'ShowInMobileList'] = [];
                $scope['patientChart' + chartSequenceClosed + 'InformationShowHeader'] = false;

                $scope.dashBoardMobileMenuOptions = true;
            };


            //this options are declared to add class to the current loaded tab
            $scope.vm.EHRWebViewInMobileOptions.ShowHideButtonBasedOnActiveTab = function () {
                $scope.ToggleActiveTabsAccordingToClick();

            };
            //this method is used to pass the menu click events and to hide show the menus content in the parent controller 
            $scope.vm.EHRWebViewInMobileOptions.ShowActiveTabOnClickEvent = function (HomeClickEventAccordingToTab) {
                //dash board click
                if (HomeClickEventAccordingToTab == 1) {
                    $scope.dashBoardClickEvent();
                }
                    //inbox click
                else if (HomeClickEventAccordingToTab == 2) {
                    $scope.inboxClickEvent();
                }
            }
            //this method is used to pass event to home controller to perform patient chart menu actions 
            $scope.vm.EHRWebViewInMobileOptions.PatientChartReturnTabOnClickEvent = function (chartSeq) {
                //$scope.MobileContentHideShowFunction();
                //$scope.ToggleActiveTabsAccordingToClick();
                $scope.patientChartClickEvent(chartSeq);
            };



            //this method is used to pass event to home controller to perform patient chart menu actions 
            $scope.vm.EHRWebViewInMobileOptions.PerformMobileViewActions = function (tabSeq) {


                $scope.vm.EHRWebViewInMobileOptions.ShowActiveTabOnClickEventWithPreviousContent(tabSeq, false);
                ////tabSeq = tabSeq.toString();

                ////dashboard
                //if (tabSeq == 1) {
                //    $scope.dashBoardMobileMenuOptions = true;
                //    $scope.inboxMenuMobileOptions = false;

                //    $scope.patientChart1InformationShow = false;
                //    $scope.patientChart2InformationShow = false;
                //    $scope.patientChart3InformationShow = false;

                //    //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for the dashboard
                //    $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, tabSeq);
                //    //showing the mobile view content
                //    $scope.previousLoadedWindowClickEvent();
                //    //calling the home parent function to hide show thr rwquired controls
                //    $scope.vm.EHRWebViewInMobileOptions.PerformHideShowActions(tabSeq);

                //}

                //else if (tabSeq == 2) {
                //    $scope.inboxMenuMobileOptions = true;
                //    $scope.dashBoardMobileMenuOptions = false;

                //    $scope.patientChart1InformationShow = false;
                //    $scope.patientChart2InformationShow = false;
                //    $scope.patientChart3InformationShow = false;
                //    //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for the inbox
                //    $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, tabSeq);
                //    $scope.previousLoadedWindowIconHideShow = true;
                //    $scope.previousLoadedWindowClickEvent();
                //    $scope.vm.EHRWebViewInMobileOptions.PerformHideShowActions(tabSeq);
                //}

                //else if (tabSeq >= 3) {


                //    $scope.patientChart1InformationShow = false;
                //    $scope.patientChart2InformationShow = false;
                //    $scope.patientChart3InformationShow = false;

                //    $scope.previousLoadedWindowIconHideShow = true;
                //    $scope.inboxMenuMobileOptions = false;
                //    $scope.dashBoardMobileMenuOptions = false;


                //    if (tabSeq == 3) {
                //        $scope.patientChart1InformationShow = true;
                //    }
                //    else if (tabSeq == 4) {
                //        $scope.patientChart2InformationShow = true;

                //    }
                //    else if (tabSeq == 5) {
                //        $scope.patientChart3InformationShow = true;
                //    }


                //    $scope.vm.EHRWebViewInMobileOptions.PerformHideShowActions(tabSeq);
                //    $scope.previousLoadedWindowClickEvent();
                //    //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for the patient charts
                //    $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, tabSeq);
                //}

            };


            $scope.vm.EHRWebViewInMobileOptions.ShowActiveTabOnClickEventWithPreviousContent = function (tabSeq, previousNotClick) {


                switch (tabSeq) {
                    //dashboard
                    case 1:
                        $scope.dashBoardMobileMenuOptions = true;
                        $scope.inboxMenuMobileOptions = false;
                        $scope.patientChart1InformationShow = false;
                        $scope.patientChart2InformationShow = false;
                        $scope.patientChart3InformationShow = false;
                        break;
                        //inbox
                    case 2:
                        $scope.dashBoardMobileMenuOptions = false;
                        $scope.inboxMenuMobileOptions = true;
                        $scope.patientChart1InformationShow = false;
                        $scope.patientChart2InformationShow = false;
                        $scope.patientChart3InformationShow = false;
                        break;
                        //Scheduler
                    case 6:
                        $scope.dashBoardMobileMenuOptions = false;
                        $scope.inboxMenuMobileOptions = false;
                        $scope.patientChart1InformationShow = false;
                        $scope.patientChart2InformationShow = false;
                        $scope.patientChart3InformationShow = false;
                        break;

                        //chart1 
                    case 3:
                        $scope.dashBoardMobileMenuOptions = false;
                        $scope.inboxMenuMobileOptions = false;
                        $scope.patientChart1InformationShow = true;
                        $scope.patientChart2InformationShow = false;
                        $scope.patientChart3InformationShow = false;
                        break;
                        //chart2 
                    case 4:
                        $scope.dashBoardMobileMenuOptions = false;
                        $scope.inboxMenuMobileOptions = false;
                        $scope.patientChart1InformationShow = false;
                        $scope.patientChart2InformationShow = true;
                        $scope.patientChart3InformationShow = false;
                        break;
                        //chart3
                    case 5:
                        $scope.dashBoardMobileMenuOptions = false;
                        $scope.inboxMenuMobileOptions = false;
                        $scope.patientChart1InformationShow = false;
                        $scope.patientChart2InformationShow = false;
                        $scope.patientChart3InformationShow = true;
                        break;
                    default:
                        break;

                }

                if (EHRisMobile.anyMobile())
                    $(window).scrollTop(0);

                //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for the dashboard
                $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, tabSeq);

                //when it is of inbox type and it is of 1st click for inbox
                if (previousNotClick && tabSeq == 2 && $scope.homePageMobileLoadPreviousContentIsInBoxFoldersOpened == false) {

                    $scope.previousLoadedWindowClickEvent(false);
                    return;
                    //not doing the following actions since no need to show folder icon
                }


                //showing the mobile view content
                $scope.previousLoadedWindowClickEvent(previousNotClick);


                //calling the home parent function to hide show thr rwquired controls
                $scope.vm.EHRWebViewInMobileOptions.PerformHideShowActions(tabSeq);

                //$scope.patientChartClickEvent(chartSeq);


            };


        }

        $scope.inboxMenuMobileOptions = false;
        $scope.patientChart1InformationShow = false;
        $scope.patientChart2InformationShow = false;
        $scope.patientChart3InformationShow = false;
        $scope.dashBoardMobileMenuOptions = true;

    };
    //############# PAGE INITLIZATION BLOCK END  ##################

    //

    //############# METHOD IS USED TO TOGGLE ACTIVE TABS  BLOCK START  ##################
    //*******PURPOSE: THIS METHOD IS USED TO TOGGLE THE ACTIVE TABS
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    $scope.ToggleActiveTabsAccordingToClick = function () {
        //dash board
        if (adminActiveTabID == "1") {
            $scope.patientChart1InformationShow = false;
            $scope.patientChart2InformationShow = false;
            $scope.patientChart3InformationShow = false;
            $scope.inboxMenuMobileOptions = false;
            $scope.dashBoardMobileMenuOptions = true;
        }
            //inbox
        else if (adminActiveTabID == "2") {
            $scope.patientChart1InformationShow = false;
            $scope.patientChart2InformationShow = false;
            $scope.patientChart3InformationShow = false;
            $scope.inboxMenuMobileOptions = true;
            $scope.dashBoardMobileMenuOptions = false
        }
            //chart 1
        else if (adminActiveTabID == "3") {
            $scope.patientChart1InformationShow = true;
            $scope.patientChart2InformationShow = false;
            $scope.patientChart3InformationShow = false;
            $scope.inboxMenuMobileOptions = false;
            $scope.dashBoardMobileMenuOptions = false;
        }
            //chart 2
        else if (adminActiveTabID == "4") {
            $scope.patientChart1InformationShow = false;
            $scope.patientChart2InformationShow = true;
            $scope.patientChart3InformationShow = false;
            $scope.inboxMenuMobileOptions = false;
            $scope.dashBoardMobileMenuOptions = false;

        }
            //chart 3
        else if (adminActiveTabID == "5") {
            $scope.patientChart1InformationShow = false;
            $scope.patientChart2InformationShow = false;
            $scope.patientChart3InformationShow = true;
            $scope.inboxMenuMobileOptions = false;
            $scope.dashBoardMobileMenuOptions = false;
        }


    }
    //############# METHOD IS USED TO TOGGLE ACTIVE TABS  BLOCK END  ##################


    //#################### METHOD TO HIDE SHOW THE CONTEXT MENU OPTIONS IN MOBILE VIEW BLOCK START ######################
    //*******PURPOSE: THIS METHOD TO HIDE SHOW THE MENU OPTIONS IN MOBILE
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ######################
    //dashboard click event
    $scope.dashBoardClickEvent = function () {

        //if already shown it then
        //if ($scope.dashBoardMobileMenuOptions) {
        //    $scope.ehrCurrentLoadedViewToggleContent();
        //}
        //else {
        $scope.dashBoardMobileMenuOptions = true;
        $scope.inboxMenuMobileOptions = false;

        $scope.patientChart1InformationShow = false;
        $scope.patientChart2InformationShow = false;
        $scope.patientChart3InformationShow = false;
        //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for the dashboard
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, 1);
        $scope.previousLoadedWindowIconHideShow = true;
        $scope.previousLoadedWindowClickEvent();
        //calling the home parent function to hide show thr rwquired controls
        $scope.vm.EHRWebViewInMobileOptions.PerformHideShowActions();
        //}
    };
    //inbox click event
    $scope.inboxClickEvent = function () {

        ////if already shown it then
        //if ($scope.inboxMenuMobileOptions) {
        //    $scope.ehrCurrentLoadedViewToggleContent();
        //}
        //else {
        $scope.inboxMenuMobileOptions = true;
        $scope.dashBoardMobileMenuOptions = false;

        $scope.patientChart1InformationShow = false;
        $scope.patientChart2InformationShow = false;
        $scope.patientChart3InformationShow = false;
        //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for the inbox
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, 2);
        $scope.previousLoadedWindowIconHideShow = true;
        $scope.previousLoadedWindowClickEvent();
        $scope.vm.EHRWebViewInMobileOptions.PerformHideShowActions();
        //}
    };


    $scope.ehrCurrentLoadedViewToggleContent = function () {
        //changing the view from regular window content to mobile menu content
        if ($(".divEhrMainPageContentClass").hasClass("visible-xs")) {
            $(".divEhrMainPageContentClass").removeClass("visible-xs").addClass("hidden-xs");
            $(".divehrMobileFoldersDetails").removeClass("hidden-xs").addClass("visible-xs");
            $('html, body').removeClass('applyOverflow').addClass('removeOverflowY');
        }
        else {
            $(".divEhrMainPageContentClass").removeClass("hidden-xs").addClass("visible-xs");
            $(".divehrMobileFoldersDetails").removeClass("visible-xs").addClass("hidden-xs");
            $('html, body').removeClass('removeOverflowY').addClass('applyOverflow');
        }
        if (EHRisMobile.anyMobile())
            $(window).scrollTop(0);
    };


    //patient chart click event
    $scope.patientChartClickEvent = function (chartSeq) {

        //var goneInside = false;

        //if (chartSeq == 1) {
        //    if ($scope.patientChart1InformationShow) {
        //        $scope.ehrCurrentLoadedViewToggleContent();
        //        goneInside = true;
        //    }
        //}
        //else if (chartSeq == 2) {
        //    if ($scope.patientChart2InformationShow) {
        //        $scope.ehrCurrentLoadedViewToggleContent();
        //        goneInside = true;
        //    }
        //}
        //else if (chartSeq == 3) {
        //    if ($scope.patientChart3InformationShow) {
        //        $scope.ehrCurrentLoadedViewToggleContent();
        //        goneInside = true;
        //    }
        //}

        //if (goneInside) return;
        chartSeq = parseInt(chartSeq);
        $scope.vm.EHRWebViewInMobileOptions.PerformHideShowActions();


        $scope.patientChart1InformationShow = false;
        $scope.patientChart2InformationShow = false;
        $scope.patientChart3InformationShow = false;

        $scope.previousLoadedWindowIconHideShow = true;
        $scope.inboxMenuMobileOptions = false;
        $scope.dashBoardMobileMenuOptions = false;


        if (chartSeq == 1) {
            $scope.patientChart1InformationShow = true;
        }
        else if (chartSeq == 2) {
            $scope.patientChart2InformationShow = true;

        }
        else if (chartSeq == 3) {
            $scope.patientChart3InformationShow = true;
        }



        $scope.previousLoadedWindowClickEvent();



        //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for the patient charts
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, chartSeq + 2);
    };



    //#################### METHOD TO HIDE SHOW THE CONTEXT MENU OPTIONS IN MOBILE VIEW BLOCK END ######################





    //declaring colors for menus
    $scope.ehrMobileFoldersDetailsColours = ["#0561ad !important", "rgba(109, 25, 107, 0.93) !important", "rgba(165, 139, 25, 0.96) !important", "rgba(239, 29, 29, 0.83) !important",
    "rgba(21, 113, 121, 0.79) !important", "#59b756 !important", "#e25b36 !important", "rgba(222, 119, 17, 0.87) !important", "rgba(23, 79, 123, 0.89) !important"];

    //static details for dashboard menus
    $scope.ehrMobileFoldersDetails = [


     //{


     //    "DashBoardType": 0,
     //    "Direction": 0,
     //    "EHRDashBoardCaseLoadReportCustType": 0,
     //    "EHRDashBoardFolderColorInfo": "rgba(49,133,155,1)",
     //    "EHRDashBoardFolderReportType": 0,
     //    "EHRDashBoardIsTopMenuCustomized": false,
     //    "EHRDashBoardShowFolderInMobile": true,
     //    "EHRDashBoardTopMenuCustomisationUserID": 0,
     //    "EMRDashBoardMenuInfoIdToBeSwapped": 0,
     //    "EMRRoleID": 0,
     //    "EMRWebDashBoardMenuDescription": null,
     //    "EMRWebDashBoardMenuDisplayName": "Appointment Scheduler Format1",
     //    "EMRWebDashBoardMenuDisplaySequence": 0,
     //    "EMRWebDashBoardMenuInfoID": 1,
     //    "EMRWebDashBoardMenuInfoIDs": null,
     //    "EMRWebDashBoardMenuInfoMultipleIDs": null,
     //    "EMRWebDashBoardMenuName": "Appointment Scheduler Format1",
     //    "EMRWebDashBoardMenuParentItemID": 0,
     //    "EMRWebDashBoardMenuRoleCustomizationInfoIDs": null,
     //    "EMRWebDashBoardMenuType": 1,
     //    "EMRWebDashBoardMenuUserCustomizationInfoID": 1,
     //    "EMRWebDashBoardType": 0,
     //    "FromUserID": 0,
     //    "IsDefaultDashboardView": false,
     //    "IsHavingCustamization": false,
     //    "ParentName": "Appointment Scheduler Format1",
     //    "RoleName": null,
     //    "SettingMenuDisplayName": "",
     //    "ShowDashBoardMenusofHidded": null,
     //    "ToUserIDs": null,
     //    "UserType": 0,
     //    "classStatus": "inactive",
     //    "dashBoardMenuSubItems": null,
     //    "dashBoardMultipleMenusCustomizationModelList": null,
     //    "name": "Appointments",
     //    "parentid": 0,
     //    "routename": "AppointmentScheduler",	
     //    "color": "rgba(3, 69, 78, 0.74) !important",
     //    "icon": "brankic-calendar",
     //},


     //{
     //    "DashBoardType": 0,
     //    "Direction": 0,
     //    "EHRDashBoardCaseLoadReportCustType": 0,
     //    "EHRDashBoardFolderColorInfo": "rgba(155,187,89,1)",
     //    "EHRDashBoardFolderReportType": 0,
     //    "EHRDashBoardIsTopMenuCustomized": false,
     //    "EHRDashBoardShowFolderInMobile": false,
     //    "EHRDashBoardTopMenuCustomisationUserID": 0,
     //    "EMRDashBoardMenuInfoIdToBeSwapped": 0,
     //    "EMRRoleID": 0,
     //    "EMRWebDashBoardMenuDescription": null,
     //    "EMRWebDashBoardMenuDisplayName": "Appointment Scheduler Format2",
     //    "EMRWebDashBoardMenuDisplaySequence": 0,
     //    "EMRWebDashBoardMenuInfoID": 74,
     //    "EMRWebDashBoardMenuInfoIDs": null,
     //    "EMRWebDashBoardMenuInfoMultipleIDs": null,
     //    "EMRWebDashBoardMenuName": "Appointment Scheduler Format2",
     //    "EMRWebDashBoardMenuParentItemID": 0,
     //    "EMRWebDashBoardMenuRoleCustomizationInfoIDs": null,
     //    "EMRWebDashBoardMenuType": 1,
     //    "EMRWebDashBoardMenuUserCustomizationInfoID": 7,
     //    "EMRWebDashBoardType": 0,
     //    "FromUserID": 0,
     //    "IsDefaultDashboardView": false,
     //    "IsHavingCustamization": false,
     //    "ParentName": "Appointment Scheduler Format2",
     //    "RoleName": null,
     //    "SettingMenuDisplayName": "",
     //    "ShowDashBoardMenusofHidded": null,
     //    "ToUserIDs": null,
     //    "UserType": 0,
     //    "classStatus": "inactive",
     //    "dashBoardMenuSubItems": null,
     //    "dashBoardMultipleMenusCustomizationModelList": null,
     //    "name": "Appointment Scheduler",
     //    "parentid": 0,
     //    "routename": "AppointmentSchedulerFormat2",
     //    "color": "rgba(3, 69, 78, 0.74) !important",
     //    "icon": "brankic-calendar",
     //},


             {
                 name: "Easyforms",
                 color: "rgba(23, 79, 123, 0.89) !important",
                 icon: "brankic-files",
             },
             {
                 name: "Billing",
                 color: "rgba(222, 119, 17, 0.87) !important",
                 icon: "brankic-money-bag"
             },
             {
                 name: "Labs",
                 color: "#e25b36 !important",
                 icon: "brankic-health",
             },
             {

                 name: "Bed Census",
                 color: "#59b756 !important",
                 icon: "brankic-inbox",

             },
             {

                 name: "Imaging",
                 color: "rgba(21, 113, 121, 0.79) !important",
                 icon: "brankic-health",

             },
             {
                 name: "Search Patient",
                 color: "rgba(239, 29, 29, 0.83) !important",
                 icon: "brankic-magnifier",
             },
             {
                 name: "RX",
                 color: "rgba(165, 139, 25, 0.96) !important",
                 icon: "brankic-pen2",
             },
             {
                 name: "Vaccines",
                 color: "rgba(109, 25, 107, 0.93) !important",
                 icon: "brankic-health",
             },
             {
                 name: "Dashboard",
                 color: "#0561ad !important",
                 icon: "brankic-profile3",
             }];

    //######### DASHBOARD LEFT FOLDERS LINKED LIST FOR MOBILE BLOCK START ############## 
    //*******PURPOSE: THIS METHOD IS USED TO GET DASHBOARD LEFT LINKED FOLDERS FOR MOBILE UI VIEW  
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.dashboardLeftFoldersLinkedListForMobile = function () {
        //debugger;
        if ($scope.dashBoardMenuItems.length > 0) {

            //var itemsToShowInMObileUI = $.grep($scope.dashBoardMenuItems, function (folder) {
            //    //showing not desktop menus
            //    return folder.EHRDashBoardFolderShowin != 1;//1 - desktop 2-mobile 3 -both
            //})


            var itemsToShowInMObileUI = angular.copy($scope.dashBoardMenuItems);

            if (itemsToShowInMObileUI.length > 0) {

                //sorting the array by mobile display sequence
                //itemsToShowInMObileUI.sortByKey("EHRDashBoardFolderMobileDisplaySequence");

                var ehrMobileFoldersDetailsLength = $scope.ehrMobileFoldersDetails.length;

                for (var indexItems = 0; indexItems < ehrMobileFoldersDetailsLength; indexItems++) {
                    if (hasValue(itemsToShowInMObileUI[indexItems]))
                        itemsToShowInMObileUI[indexItems].color = $scope.ehrMobileFoldersDetails[indexItems].color;
                }

                //looping on all the dash board items to assign the background color
                var allDashBoardItemsLength = itemsToShowInMObileUI.length;
                var copiedObjects = angular.copy(itemsToShowInMObileUI);

                for (var indexItems = 0; indexItems < allDashBoardItemsLength; indexItems++) {
                    if (!hasValue(copiedObjects[indexItems].color))
                        copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
                }

                $scope.dashfolderShowInMobileList = copiedObjects;

                //var allDashBoardItemsLength = itemsToShowInMObileUI.length;
                //var copiedObjects = angular.copy(itemsToShowInMObileUI);

                //for (var indexItems = 0; indexItems < allDashBoardItemsLength; indexItems++) {
                //    copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
                //}

                //$scope.dashfolderShowInMobileList = copiedObjects;


            }
                //not showing any list since there are no items configured for mobile
            else
                $scope.dashfolderShowInMobileList = [];


            //else {
            //    //showing all the items list
            //    // alert("No items linked to show in mobile ui");

            //    var allDashBoardItemsLength = $scope.dashBoardMenuItems.length;
            //    var copiedObjects = angular.copy($scope.dashBoardMenuItems);

            //    for (var indexItems = 0; indexItems < allDashBoardItemsLength; indexItems++) {
            //        copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
            //    }

            //    $scope.dashfolderShowInMobileList = copiedObjects;

            //}
        }




    }
    //######### DASHBOARD LEFT FOLDERS LINKED LIST FOR MOBILE BLOCK END ##############


    //######### INBOX LIST FOR MOBILE BLOCK START ############## 
    //*******PURPOSE: THIS METHOD IS USED TO GET INBOX LIST FOR MOBILE UI VIEW  
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.inboxLinkedListForMobile = function () {

        if ($scope.inboxMenuItemsForMobile.length > 0) {
            var allInboxItemsLength = $scope.inboxMenuItemsForMobile.length;
            var copiedObjects = angular.copy($scope.inboxMenuItemsForMobile);

            for (var indexItems = 0; indexItems < allInboxItemsLength; indexItems++) {
                copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
            }

            //sorting the array by key name
            copiedObjects.sortByKey("inboxUnSignedItemMobileDisplaySequence");

            //getting only items to show in mobile
            var copiedObjectstemp = $.grep(copiedObjects, function (item) {
                //getting both and only mobile by excluding desktop only
                return (item.inboxUnSignedItemShowIn != 1);
            });

            if (copiedObjectstemp && copiedObjectstemp.length > 0) {
                copiedObjects = copiedObjectstemp;
            }
            else
                copiedObjects = [];
            //assigning empty array when there are no items customized for mobile
            $scope.inboxShowInMobileList = copiedObjects;
        }
    }
    //######### DASHBOARD LEFT FOLDERS LINKED LIST FOR MOBILE BLOCK END ##############


    //######### PATIENT CHART LIST FOR MOBILE BLOCK START ############## 
    //*******PURPOSE: THIS METHOD IS USED TO GET PATIENT CHART LIST FOR MOBILE UI VIEW  
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.patientChartListForMobile = function () {
        if ($scope.inboxMenuItemsForMobile.length > 0) {
            var allInboxItemsLength = $scope.inboxMenuItemsForMobile.length;
            var copiedObjects = angular.copy($scope.inboxMenuItemsForMobile);

            for (var indexItems = 0; indexItems < allInboxItemsLength; indexItems++) {
                copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
            }
            $scope.inboxShowInMobileList = copiedObjects;
        }
        else
            $scope.inboxShowInMobileList = [];
    };
    //######### PATIENT CHART LIST FOR MOBILE BLOCK END ############## 

    // Simple random function
    function getRandomName(names) {
        return names[Math.floor(Math.random() * (names.length - 1))];
    }

    //######### THIS METHOD IS USED TO FOR OPENING EHR MOBILE DASHBOARD SUB MENU POPUP OPENING BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO FOR OPENING DASHBOARD SUB MENU POPUP OPENING 
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.ehrMobileDashboardOpenFolder = function (dashboardMenu) {
        $scope.previousLoadedWindowIconHideShow = true;
        if (!hasValue(dashboardMenu)) return false;

        // when there are sub items and their length is greater than 1
        if (hasValue(dashboardMenu.dashBoardMenuSubItems) && dashboardMenu.dashBoardMenuSubItems.length > 0) {

            var subMenuListToPass = $.grep(dashboardMenu.dashBoardMenuSubItems, function (SubMenuInfo) {
                //except desktop menu items
                return SubMenuInfo.EHRDashBoardFolderShowin != 1;
            });
            if (hasValue(subMenuListToPass) && subMenuListToPass.length > 0) {
                //when there exists only one sub menu item then opening it 
                if (subMenuListToPass.length == 1) {
                    $scope.ehrMobileFoldersDetailsClick(subMenuListToPass[0]);
                }
                else {
                    // passing sub items to sub items popup
                    var postData = {
                        FolderName: dashboardMenu.name,
                        DashboardSubmenus: dashboardMenu.dashBoardMenuSubItems
                    };

                    ModalPopupService.OpenPopup(GetEMRPageURLByIndex(2483), postData, 'sm').then(function (dashboardSubMenu) {
                        if (hasValue(dashboardSubMenu) && dashboardSubMenu != "cancel") {
                            // collecting sub menu from the sub menu items popup
                            $scope.ehrMobileFoldersDetailsClick(dashboardSubMenu);
                            // $("#sidebar-default").show();
                        }
                    });
                }
            }
            else {
                if (dashboardMenu.EMRWebDashBoardMenuType == 0) {
                    ShowErrorMessage("No Sub Folder(s) Customized for Mobile View.");
                    return false;
                }
                else
                    $scope.ehrMobileFoldersDetailsClick(dashboardMenu);
            }
        } else {
            // triggering home set default function 
            $scope.ehrMobileFoldersDetailsClick(dashboardMenu);
            // $("#sidebar-default").hide();
            // $("#leftnaviconmobchangeIcon").attr("title", "Collapse");
            // toggleClassOfTheElement($("#leftnaviconmobchangeIcon"));
            showHideLeftNavBasedONBodyClass();
            //ShowErrorMessage("No Sub Folder(s) Exits.");
            //return;

        }

    };
    //######### THIS METHOD IS USED TO FOR OPENING EHR MOBILE DASHBOARD SUB MENU POPUP OPENING BLOCK END ##############


    // mobile folder detail click
    $scope.ehrMobileFoldersDetailsClick = function (clickedFlderInfo) {
        $scope.MobileContentHideShowFunction();
        $scope.homeSetDefaultMenuItem([clickedFlderInfo], true);
        //this method is used to hide show the respective icons in the parent controller
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(6, 1);

    };

    //######### THIS METHOD IS USED TO OPEN SELECTED DASHBOARD BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO FOR OPENING THE SELECTED DASHBOARD LINK
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.homeSetDefaultMenuItem = function (dfaultchildItemtoload, fromMobileView) {
        //this method is used to active the respective links on click
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, 1);

        if ($(".divehrMobileFoldersDetails").hasClass("visible-xs")) {
            return;
        }

        if (dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID <= 0) {


            if (EMRPracticeModel.UserType == EHRLoggedUserType.SECADMIN) {


                var menuinfoidstr = "[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "][data-secid=" + dfaultchildItemtoload[0].EMRWebDashBoardMenuInfoID + "]";

                $(menuinfoidstr).parents("a").addClass("toggled");

                $(menuinfoidstr).parents("ul").css({
                    "display": "block"
                });

                $timeout(function () {
                    $(menuinfoidstr).trigger("click"); // convert inputEl into a jQuery object first
                });
                var menuItem = $(menuinfoidstr);


                if (fromMobileView && menuItem.click != undefined && menuItem.click != null) {
                    $timeout(function () {
                        menuItem.click();
                    });
                }



            }
            else {
                $($("[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "]")[0]).parents("a").addClass("toggled");
                $($("[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "]")[0]).parents("ul").css({
                    "display": "block"
                });
                $timeout(function () {
                    $($("[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "]")[0]).trigger("click"); // convert inputEl into a jQuery object first
                });
            }
        }
        else {
            $("[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "]").parents("a").addClass("toggled");
            $("[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "]").parents("ul").css({
                "display": "block"
            });
            $timeout(function () {
                $("[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "]").trigger("click"); // convert inputEl into a jQuery object first
            });
            var menuItem = $("[data-menuinfoid = " + dfaultchildItemtoload[0].EMRWebDashBoardMenuUserCustomizationInfoID + "_" + dfaultchildItemtoload[0].EMRWebDashBoardMenuType + "]");


            if (fromMobileView && menuItem.click != undefined && menuItem.click != null) {
                $timeout(function () {
                    menuItem.click();
                });
            }

        }
    };
    //######### THIS METHOD IS USED TO OPEN SELECTED DASHBOARD BLOCK END ##############


    //######### THIS METHOD IS USED TO LOGOUT BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO RETURN THE LOGIN PAGE
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.LogOut = function (isAutoLogOut) {

        //this condition is added by mahesh p since while version updated no need of asking the confirmations so directly auto logging of the session

        //this method is used to rise the logout function in the parent controller
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(5);

        //setTimeout(function () {
        //    $scope.ehrHomePageLogoutAndNavigateToLoginPage(isAutoLogOut);
        //}, 100);


    };
    //######### THIS METHOD IS USED TO LOGOUT BLOCK END ##############




    //######### THIS METHOD IS USED TO FOR OPENING EHR MOBILE INBOX MENU OPENING BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO FOR OPENING INBOX MENU OPENING 
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.ehrMobileInboxOpenFolder = function (inboxMenu) {
        $scope.previousLoadedWindowIconHideShow = true;
        $scope.ehrMobileInboxFoldersDetailsClick(inboxMenu);
    };
    //######### THIS METHOD IS USED TO FOR OPENING EHR MOBILE INBOX MENU OPENING BLOCK END ##############

    //// mobile folder detail click
    //$scope.ehrMobileInboxFoldersDetailsClick = function (clickedFlderInfo, menu) {
    //    $scope.MobileContentHideShowFunction();
    //    $("#spnInboxMenu" + menu.UnsignedItemLinkedType + menu.CategoryIds).trigger("click");
    //};


    //MOBILE INBOX DETAIL VIEW BLOCK START
    $scope.ehrMobileInboxFoldersDetailsClick = function (menu, fromMobileView) {
        //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for inbox
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, 2);

        $scope.MobileContentHideShowFunction();
        //assaigning count on individual refress
        if (hasValue(menu) && hasValue(menu.UnsignedItemLinkedType) && hasValue(menu.CategoryIds)) {
            $("#spnInboxMenu_" + menu.UnsignedItemLinkedType + "_" + menu.CategoryIds).parents("a").addClass("toggled");
            $("#spnInboxMenu_" + menu.UnsignedItemLinkedType + "_" + menu.CategoryIds).parents("ul").css({
                "display": "block"
            });
            $timeout(function () {
                $("#spnInboxMenu_" + menu.UnsignedItemLinkedType + "_" + menu.CategoryIds).trigger("click"); // convert inputEl into a jQuery object first
                angular.element("#spnInboxMenu_" + menu.UnsignedItemLinkedType + "_" + menu.CategoryIds).trigger("click");
            });
            var menuItem = $("#spnInboxMenu_" + menu.UnsignedItemLinkedType + "_" + menu.CategoryIds);

            if (fromMobileView && menuItem.click != undefined && menuItem.click != null) {
                $timeout(function () {
                    menuItem.click();
                })
            }
        }
        //this method is hide show the icons of respective menus in the parent controller
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(6, 2);

        //indicating that a menu item was opened in the inbox
        $scope.homePageMobileLoadPreviousContentIsInBoxFoldersOpened = true;
    };

    //######### THIS METHOD IS USED TO HIDE SHOW THE MAINPAGE AND MOBILE PAGE CONTENT BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO HIDE SHOW THE CONTENT
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.MobileContentHideShowFunction = function () {
        if ($(".divehrMobileFoldersDetails").hasClass("visible-xs")) {
            $(".divehrMobileFoldersDetails").removeClass("visible-xs").addClass("hidden-xs");
            $(".divEhrMainPageContentClass").removeClass("hidden-xs").addClass("visible-xs");
            $('html, body').removeClass('removeOverflowY').addClass('applyOverflow');
            // $("#sidebar-default").hide();
            // $("#leftnaviconmobchangeIcon").attr("title", "Collapse");
            // toggleClassOfTheElement($("#leftnaviconmobchangeIcon"));
            //showHideLeftNavBasedONBodyClass();
        }
        else {
            $(".divehrMobileFoldersDetails").removeClass("hidden-xs").addClass("visible-xs");
            $(".divEhrMainPageContentClass").removeClass("visible-xs").addClass("hidden-xs");
            $('html, body').removeClass('applyOverflow').addClass('removeOverflowY');
        }
        if (EHRisMobile.anyMobile())
            $(window).scrollTop(0);
    }
    //######### THIS METHOD IS USED TO HIDE SHOW THE MAINPAGE AND MOBILE PAGE CONTENT BLOCK END ##############



    //######### THIS METHOD IS USED TO FOR OPENING EHR MOBILE PATIENT CHART MENU OPENING BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO FOR OPENING PATIENT CHART MENU OPENING 
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.ehrMobilePatientChartOpenFolder = function (patientChartMenu, chartSequence) {

        $scope.previousLoadedWindowIconHideShow = true;

        if (!hasValue(patientChartMenu)) return false;

        // when there are sub items and their length is greater than 1
        if (hasValue(patientChartMenu.PatientChartLeftSideLinksModelChildList) && patientChartMenu.PatientChartLeftSideLinksModelChildList.length > 0) {


            var temppatientChartMenuPatientChartLeftSideLinksModelChildList = $.grep(patientChartMenu.PatientChartLeftSideLinksModelChildList, function (subfolder) {
                //except desktop menu items
                return subfolder.ShowIn != 1;
            });

            if (hasValue(temppatientChartMenuPatientChartLeftSideLinksModelChildList) && temppatientChartMenuPatientChartLeftSideLinksModelChildList.length > 0) {

                //when there exists only one item then
                if (temppatientChartMenuPatientChartLeftSideLinksModelChildList.length == 1) {
                    // collecting sub menu from the sub menu items popup
                    $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, chartSequence + 2);
                    $scope.ehrMobilePatientChartFoldersDetailsClick(temppatientChartMenuPatientChartLeftSideLinksModelChildList[0], chartSequence);
                }
                else {
                    // passing sub items to sub items popup
                    var postData = {
                        FolderName: patientChartMenu.PatientChartName,
                        PatientChartSubmenus: patientChartMenu.PatientChartLeftSideLinksModelChildList
                    };

                    ModalPopupService.OpenPopup(GetEMRPageURLByIndex(2544), postData, 'sm').then(function (patientChartSubMenu) {

                        if (hasValue(patientChartSubMenu) && patientChartSubMenu != "cancel") {

                            // collecting sub menu from the sub menu items popup
                            $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, chartSequence + 2);
                            $scope.ehrMobilePatientChartFoldersDetailsClick(patientChartSubMenu, chartSequence);

                        }
                    });
                }
            }
            else {
                ShowErrorMessage("No Sub Folder(s) Customized for Mobile View");
                return false;
            }
        }
        else {
            //ShowErrorMessage("No Sub Folder(s) Exits.");
            //return;
            //this method is used to make the toggle the active item when content was toggled to desktop and viceversa for Patient Chart
            $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(2, chartSequence + 2);
            $scope.ehrMobilePatientChartFoldersDetailsClick(patientChartMenu, chartSequence);
        }

    }
    //######### THIS METHOD IS USED TO FOR OPENING EHR MOBILE DASHBOARD SUB MENU POPUP OPENING BLOCK END ##############


    //PATIENT CHART DETAIL CLICK EVENT
    $scope.ehrMobilePatientChartFoldersDetailsClick = function (defaultLoadRouteName, chartSequence) {
        defaultLoadRouteName = [defaultLoadRouteName];
        $scope.MobileContentHideShowFunction();

        var patientID;

        if (chartSequence == 1) patientID = $scope.patientChart1PatientInfo.PatientID;
        else if (chartSequence == 2) patientID = $scope.patientChart2PatientInfo.PatientID;
        else if (chartSequence == 3) patientID = $scope.patientChart3PatientInfo.PatientID;


        //If defaultLoadRouteName has value , then load that menu item when the user opened the patient chart
        $("[data-menuinfopatientid=" + defaultLoadRouteName[0].PatientChartID + "_" + patientID + "]").focus();

        $timeout(function () {
            $("[data-menuinfopatientid=" + defaultLoadRouteName[0].PatientChartID + "_" + patientID + "]").trigger("click");
            $("[data-menuinfopatientid=" + defaultLoadRouteName[0].PatientChartID + "_" + patientID + "]").trigger("click");
        })
        
        $("[data-menuinfopatientid=" + defaultLoadRouteName[0].PatientChartID + "_" + patientID + "]").children("a").addClass("active");
        var menuItem = $("[data-menuinfopatientid=" + defaultLoadRouteName[0].PatientChartID + "_" + patientID + "]");
        if (menuItem.click != undefined && menuItem.click != null) {
            $timeout(function () {
                menuItem.click();
            })
        }
        //this method is used to hide show the menus in the parent controller
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(6, chartSequence + 2);
    };

    //######### PATIENT CHART LIST FOR MOBILE BLOCK START ############## 
    //*******PURPOSE: THIS METHOD IS USED TO GET PATIENT CHART LIST FOR MOBILE UI VIEW  
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.ehrMobilePatientChart1List = function () {

        var allPatientChartItemsLength = $scope.patientChart1ShowInMobileList.length;
        var copiedObjects = angular.copy($scope.patientChart1ShowInMobileList);

        for (var indexItems = 0; indexItems < allPatientChartItemsLength; indexItems++) {
            copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
        }

        $scope.patientChart1ShowInMobileList = copiedObjects;

    };
    //######### PATIENT CHART LIST FOR MOBILE BLOCK END ############## 

    //######### PATIENT CHART 2 LIST FOR MOBILE BLOCK START ############## 
    //*******PURPOSE: THIS METHOD IS USED TO GET PATIENT CHART 2 LIST FOR MOBILE UI VIEW  
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.ehrMobilePatientChart2List = function () {
        var allPatientChart2ItemsLength = $scope.patientChart2ShowInMobileList.length;
        var copiedObjects = angular.copy($scope.patientChart2ShowInMobileList);

        for (var indexItems = 0; indexItems < allPatientChart2ItemsLength; indexItems++) {
            copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
        }

        $scope.patientChart2ShowInMobileList = copiedObjects;


    };
    //######### PATIENT CHART 2 LIST FOR MOBILE BLOCK END ############## 

    //######### PATIENT CHART 3 LIST FOR MOBILE BLOCK START ############## 
    //*******PURPOSE: THIS METHOD IS USED TO GET PATIENT CHART 3 LIST FOR MOBILE UI VIEW  
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.ehrMobilePatientChart3List = function () {
        var allPatientChart3ItemsLength = $scope.patientChart3ShowInMobileList.length;
        var copiedObjects = angular.copy($scope.patientChart3ShowInMobileList);
        for (var indexItems = 0; indexItems < allPatientChart3ItemsLength; indexItems++) {
            copiedObjects[indexItems].color = getRandomName($scope.ehrMobileFoldersDetailsColours);
        }
        $scope.patientChart3ShowInMobileList = copiedObjects;
    };
    //######### PATIENT CHART 3 LIST FOR MOBILE BLOCK END ############## 


    //######### THIS METHOD IS USED TO SHOW THE PREVIOUS PAGE CONTENT BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO SHOW THE PREVIOUS PAGE
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.previousLoadedWindowClickEvent = function (isreverse) {

        if (isreverse) {
            //changing the view from  mobile menu content to regular window content
            if ($(".divehrMobileFoldersDetails").hasClass("visible-xs")) {
                $(".divehrMobileFoldersDetails").removeClass("visible-xs").addClass("hidden-xs");
                $(".divEhrMainPageContentClass").removeClass("hidden-xs").addClass("visible-xs");
                $('html, body').removeClass('removeOverflowY').addClass('applyOverflow');
            }
        }

        else {
            //changing the view from regular window content to mobile menu content
            if ($(".divEhrMainPageContentClass").hasClass("visible-xs")) {
                $(".divEhrMainPageContentClass").removeClass("visible-xs").addClass("hidden-xs");
                $(".divehrMobileFoldersDetails").removeClass("hidden-xs").addClass("visible-xs");

                //if (EHRisMobile.anyMobile()) {
                $('html, body').removeClass('applyOverflow').addClass('removeOverflowY');

                //}
                //else
                //    $('html, body').addClass('applyOverflow').removeClass('removeOverflowY');
            }
        }

        if (EHRisMobile.anyMobile())
            $(window).scrollTop(0);

    };
    //######### THIS METHOD IS USED TO SHOW THE PREVIOUS PAGE CONTENT BLOCK END ##############


    //######### THIS METHOD IS USED TO CLOSE THE PATIENT CHART BLOCK START ##############
    //*******PURPOSE: THIS METHOD IS USED TO SHOW THE PREVIOUS PAGE
    //*******CREATED BY: ANUSHA CH
    //*******CREATED DATE: 07/20/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; 
    $scope.closePatientChartClickEvent = function (chartSequnceNumber) {
        //this method is used to close the patient charts in the parent controller
        $scope.vm.EHRWebViewInMobileOptions.PerformHomeActions(3, chartSequnceNumber.toString());
    };
    //######### THIS METHOD IS USED TO CLOSE THE PATIENT CHART BLOCK END ##############





























































}]);

